import { Action } from "../actions/actions";
import { SkeletonActionTypes } from "../actions/actionTypes";

const initialState: boolean = false;

export function loadingReducer(state = initialState, action: Action) {
    switch (action.type) {
        /*
        case SkeletonActionTypes.GET_API_ROUTES:
            return true;

        case SkeletonActionTypes.GET_API_ROUTES_FAIL:
        case SkeletonActionTypes.GET_API_ROUTES_SUCCESS:
            return false;
        */
        default:
            return state;
    }
}
